import { render, staticRenderFns } from "./WineTransactions.vue?vue&type=template&id=3f7c004b&"
import script from "./WineTransactions.vue?vue&type=script&lang=js&"
export * from "./WineTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports